import { cloneDeep, defaultsDeep } from 'lodash'
import { Brand } from '../models/brand.entity'

/**
 * The brand initial state
 */
const BRAND_INITIAL_STATE: Partial<Brand> = {}

/**
 * Initialize a partial brand
 * @param brand - the partial brand
 * @returns the brand updated
 */
export function initBrand(brand: Partial<Brand> = {}): Brand {
  return defaultsDeep(cloneDeep(brand), BRAND_INITIAL_STATE)
}
